import { MailWarning, User, X } from "lucide-react";
import React, { useEffect, useMemo, useState } from "react";
import { SendBackAllQuizDataToClient } from "../../../store/actions/QuizAPI/createNewMockTest";
import { useDispatch } from "react-redux";

import MockTestStyles from "./MockTestStyles";
import { useSelector } from "react-redux";
import { mockTestCard1Object } from "./ExportMockTestCard1Object";
export default function QuizInstructionCards({itemId,showBtn ,setStartMock,closeInstructionPopup}) {
  const [page, setPage] = useState(showBtn?1:2);
  const [accepted, setAccepted] = useState(false);
  
       const dispatch = useDispatch()
 const currentToken = useSelector((state)=>state?.user?.user?.currentToken);
                                                 const userEmail = useSelector((state)=>state?.user?.user?.userData?.userEmail
                                                ); 
      const firstName = useSelector((state)=>state?.user?.user?.userData?.firstName);
      const AppToken = useSelector((state)=>state?.user?.user?.appToken);
      const appId = useSelector((state)=>state?.user?.user?.appId);
    
      
         const [sectionsArr, setSectionsArr] = useState([]);
                  const [questionsArr, setQuestionsArr] = useState([]);
                const [quizArr, setQuizArr] = useState(null);
                 const pages = [
  {
    id: 1,
    title: "Instructions",
    content: quizArr ? (
      <GeneralInstructions quizArr={quizArr} sectionsArr={sectionsArr}/>
    ) : (
      "Loading"
    ),
    footerRight: (
      <button style={styles.nextBtn} onClick={() => setPage(2)}>
        Next <span style={{ fontSize: 18, marginLeft: 6 }}>›</span>
      </button>
    ),
  },
  {
    id: 2,
    title: "Other Important Instructions",
    content: quizArr ?<OtherInstructions sections={sectionsArr} quizArr={quizArr} />:"loading",
    footerLeft: (
      <button style={styles.prevBtn} onClick={() => setPage(1)}>
        <span style={{ fontSize: 18, marginRight: 6 }}>‹</span> Previous
      </button>
    ),
    footerCenter: (
      <button
        style={{
          ...styles.beginBtn,
          opacity: accepted ? 1 : 0.5,
          cursor: accepted ? "pointer" : "not-allowed",
        }}
        disabled={!accepted}
        onClick={setStartMock}
      >
        I am ready to begin
      </button>
    ),
    footerBottom: (
      <label style={styles.checkboxRow}>
        <input
          type="checkbox"
          checked={accepted}
          onChange={(e) => setAccepted(e.target.checked)}
        />
        <span style={styles.checkboxText}>
       I have read all the instructions carefully and have understood them. I agree not to cheat or use any unfair means in this examination. I understand that using unfair means of any sort for my own or someone else’s advantage will lead to my immediate disqualification. The decision of the examination authority shall be final in these matters and cannot be appealed.
        </span>
      </label>
    ),
  },
];

const current = pages.find((p) => p.id === page);



               const [questionsArrDummy, setQestionsArrDummy] = useState([]);
  const [sectionStatsAll ,setSectionStatsAll]= useState({});
  useEffect(() => { fireGetAllQuizSectionsQuestionsOptionsInOne()
  const totals = {
    notVisited: 0,
    visited: 0,
    answered: 0,
    markedAndNotAnswered: 0,
    markedAndAnswered: 0
  };

  sectionsArr?.forEach(section => {
    let questions = [];
  
    try {
      questions = Array.isArray(section?.secQuestions)
        ? section?.secQuestions
        : JSON.parse(section?.secQuestions || "[]");
    } catch (e) {
     
    }
    totals.totalMarks += questions.filter(q => !q?.visited && !q?.answered && !q?.marked)?.length;
    totals.notVisited += questions.filter(q => !q?.visited && !q?.answered && !q?.marked)?.length;
    totals.visited += questions.filter(q => q?.visited && !q?.answered && !q?.marked)?.length;
    totals.answered += questions.filter(q => q?.visited && q?.answered && !q?.marked)?.length;
    totals.markedAndNotAnswered += questions.filter(q => q?.visited && !q?.answered && q?.marked)?.length;
    totals.markedAndAnswered += questions.filter(q => q?.visited && q?.answered && q?.marked)?.length;
    
  });
  // ✅ Update state once
  setSectionStatsAll(totals);
}, []); 
const getQuestionsFromOneSection = (questionsArrAll, secQuestionsIDArr) => { 
  let secQuestions = [];

  try {
    secQuestions = Array.isArray(secQuestionsIDArr)
      ? secQuestionsIDArr
      : JSON.parse(secQuestionsIDArr || '[]');
  } catch (e) {
    console.warn("Invalid JSON in secQuestions", e);
    return [];
  }}
  const fireGetAllQuizSectionsQuestionsOptionsInOne=()=>{
     
            const apiData = dispatch(SendBackAllQuizDataToClient({testName:"",type:"question",
          postParent:itemId,userEmail:userEmail?userEmail:"",
          currentToken:currentToken?currentToken:"",
          postId:itemId,menuOrder:"",appToken:AppToken,appId:appId,appAllottedToken:"",visibility:"public"}
          ));
        /* get response as Promise   */
        apiData.then(response => {
          if(response?.quiz?.quizToken){  
            
   function getSectionTotalMarks(secQuestions, questions) {
  // build a fast lookup set of section question IDs
  const secIds = new Set(secQuestions.map(q => String(q.ID)));

  return questions.reduce((total, q) => {
    if (secIds.has(String(q.ID))) {
      return total + Number(q.marks || 0);
    }
    return total;
  }, 0);
}

              setSectionsArr(response?.sections?.map(section => {
      const questions = section?.secQuestions?JSON.parse(section?.secQuestions):[];
    
      questions.forEach((q, i) => {
    const attempt = response?.attempts?.data?.[q.ID];
    if (attempt && attempt?.questionId === Number(q.ID)) {
      questions[i] = {
        ...q,
        visited: attempt?.visited ? "visited" : false,
        marked: attempt?.marked ? "marked" : false,
        answered: attempt?.answered ? "answered" : false,
        rawData: attempt?.rawData ? attempt?.rawData: null,
      };
    }
  });
   const totalSectionalMarks =(getSectionTotalMarks(questions, response?.questions))
      const totalSectionalNotVisited = questions?.filter(q =>
        !q?.visited &&
        !q?.answered &&
        !q?.marked 
      )?.length;
  
      const totalSectionalVisited = questions?.filter(q =>
        q?.visited &&
        !q?.answered &&
        !q?.marked
      )?.length;
  
      const totalSectionalAnswered = questions?.filter(q =>
        q?.visited &&
        q?.answered &&
        !q?.marked
      )?.length;
  
      const totalSectionalMarkedAndNotAnswered = questions?.filter(q =>
        q?.visited &&
        !q?.answered &&
        q?.marked
      )?.length;
  
      const totalSectionalMarkedAndAnswered = questions?.filter(q =>
        q?.visited &&
        q?.answered  &&
        q?.marked 
      )?.length;
  
     
      return {
        ...section,secQuestions:JSON.stringify(questions)
        ,
        sectionStats: {
          notVisited: totalSectionalNotVisited,
          visited: totalSectionalVisited,
          answered: totalSectionalAnswered,
          markedAndNotAnswered: totalSectionalMarkedAndNotAnswered,
          markedAndAnswered: totalSectionalMarkedAndAnswered,
          totalMarks:totalSectionalMarks
        }
      };
     
    }));
                  
  
               setQuestionsArr(getQuestionsFromOneSection(response?.questions,response?.sections?.length?response?.sections[0]?.secQuestions:[]));
            
                       setQuizArr(response?.quiz);
         
      
          }else{
              }
      
        }).catch(error => {
       
        
        });
       
        }

  return (
    <div  className="layoutWrapper">
        <div  onClick={()=>{closeInstructionPopup(true)}}style={{width:"40px",height:"40px",display:"flex",justifyContent:"center",alignItems:"center",borderRadius:"50%",position:"fixed",top:"5px",right:"5px", background:"#f1f1f1"}}><X size={20} color={"#222222"}/></div>
      {/* Top Banner */}
      <div style={styles.banner}>
        <div style={styles.bannerLeft}>
          <div style={styles.bannerLogo}>{quizArr?.testName?quizArr?.testName:"Test Name"}</div>
            </div><div style={styles.bannerSub}><h4></h4>
            
               <h3 style={styles.bannerRight}>{quizArr?.testStatus?JSON.parse(quizArr?.testStatus)?.post_title:"Type"}</h3>
            </div>
      
       
      </div>

      {/* Page Title */}
      <div style={styles.pageTitle}>{current.title}</div>

      {/* Layout */}
      <div className="layoutInstruction">
        {/* Left Content */}
        <style>{`
        .layoutWrapper{
         height: 100vh;
    background: "#e9f0f1";
    display: flex;
    flex-direction: column;
    font-family: Arial, sans-serif;}
        .layoutInstruction{
    flex: 1;
    display: grid;
    grid-template-columns: 1fr 320px;
    gap: 10;
    padding: 12;
  }
  
/* xs */
@media (max-width: 767px) {
.layoutWrapper{
         height: 100%;overflow:auto;}
.hideXsInstruction{display:none;}
.layoutInstruction{
    flex: 1;
    display: grid;
    grid-template-columns: 100% ;
    gap: 10;
    padding: 12;
  }}
  
  `}</style>
        <div style={styles.leftPanel}>
          <div style={styles.scrollArea}>
            {current.content}
          </div>
        </div>

        {/* Right Candidate Box */}
        <div  style={styles.rightPanel} className="hideXsInstruction">
          <div style={styles.userBox}>
            <div style={styles.avatar}><User size={60}/></div>
            <div style={styles.userName}>{firstName?firstName:"John Smith"}</div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={styles.footerWrap}>
        {showBtn&&current.footerBottom && <div style={styles.footerCheck}>{current.footerBottom}</div>}

        <div style={styles.footer}>
          <div style={{ width: 220 }}>{showBtn&&current.footerLeft || null}</div>
         {showBtn? <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
            {current.footerCenter || null}
          </div>:""}
          <div style={{ width: 220, display: "flex", justifyContent: "flex-end" }}>
            {showBtn&&current.footerRight || null}
          </div>
        </div>

        {/* bottom version bar */}
        <div style={styles.versionBar}>Version : 17.07.00</div>
      </div>
    </div>
  );
}

/* -------------------- PAGE CONTENTS -------------------- */

function GeneralInstructions( {quizArr,sectionsArr}) {
  if (!quizArr) return null;

  const {
    overallTestTime,
    showCalci,
    isRestrictQuestionNavigation,
    isLockSections,
    testInterfaceTheme,
    cutOffPercent,
  } = quizArr;

  return (
   <div style={styles.content}>
      <h3 style={styles.h3}>Read the following instructions carefully</h3>

      {/* ================= GENERAL INSTRUCTIONS ================= */}
      <div style={styles.sectionTitle}>General Instructions:</div>

      <ol style={styles.ol}>
        <li>
          Total duration of the examination is{" "}
          <b>{overallTestTime ? `${overallTestTime} minutes` : "loading..."}</b>.
          {showCalci === "true" && (
            <> A scientific calculator is available on the top-right corner.</>
          )}
        </li>

        <li>
          The clock will be set at the server. The countdown timer at the top
          right corner of the screen will display the remaining time available
          to complete the examination. When the timer reaches zero, the
          examination will end automatically.
        </li>

        <li>
          The Question Palette displayed on the right side of the screen will
          show the status of each question using one of the following symbols:
        </li>
      </ol>

      {/* ================= QUESTION PALETTE LEGEND ================= */}
      <div style={styles.paletteBox}>
         <StatusRow  color="#d9d9d9" label="You have NOT visited the question yet." />
      
      </div>

      <p style={styles.note}>
        <b>Note:</b> Mark for Review status indicates that you want to look at
        the question again. If a question is answered and marked for review,
        the answer will be considered for evaluation unless modified.
      </p>

      {/* ================= NAVIGATION ================= */}
      <div style={styles.sectionTitle}>Navigating to a Question:</div>

      <ol style={styles.ol}>
        <li>
          Click on the question number in the Question Palette to go directly
          to that question. Note that using this option does NOT save your
          answer to the current question.
        </li>
        <li>
          Click on <b>Save & Next</b> to save your answer and move to the next
          question.
        </li>
        <li>
          Click on <b>Mark for Review & Next</b> to mark the question for review
          and move to the next question.
        </li>
      </ol>

      <p style={styles.note}>
        Your answer will NOT be saved if you navigate away without clicking
        <b> Save & Next</b>.
      </p>

      {/* ================= ANSWERING QUESTIONS ================= */}
      <div style={styles.sectionTitle}>Answering a Question:</div>

      <ol style={styles.ol}>
        <li>
          For <b>MCQ</b> questions, choose one option by clicking on the bubble
          before the option.
        </li>
        <li>
          To change your answer, select another option.
        </li>
        <li>
          To clear your response, click on the <b>Clear Response</b> button.
        </li>
        <li>
          To save your answer, you MUST click on <b>Save & Next</b>.
        </li>
        <li>
          For numerical answer type questions, use the on-screen numerical
          keypad to enter your answer. Fractional values up to four decimal
          places are allowed.
        </li>
      </ol>

      <ol start={6} style={styles.ol}>
        <li>
          To mark a question for review, click on <b>Mark for Review & Next</b>.
          If an answer is selected and marked for review, it will be considered
          for evaluation.
        </li>
        <li>
          Only questions for which answers are saved or marked for review will
          be considered for evaluation.
        </li>
      </ol>

      {/* ================= SECTIONS ================= */}
      <div style={styles.sectionTitle}>Section Instructions:</div>

      <ol style={styles.ol}>
        <li>
          Sections are displayed on the top bar of the screen. You can switch
          sections by clicking on the section name.
        </li>

        {isLockSections === "yes" && (
          <li>
            Sections are <b>locked</b>. You must complete the current section
            before moving to the next one.
          </li>
        )}

        <li>
          After clicking <b>Save & Next</b> on the last question of a section,
          you will be automatically taken to the first question of the next
          section.
        </li>
      </ol>

      {/* ================= CUTOFF ================= */}
      {cutOffPercent && (
        <p style={styles.noteStrong}>
          Qualification Criteria: You must score at least{" "}
          <b>{cutOffPercent}%</b> marks to qualify this test.
        </p>
      )}

      {testInterfaceTheme === "CBT" && (
        <p style={styles.note}>
          This test follows a <b>Computer Based Test (CBT)</b> interface similar
          to the actual examination.
        </p>
      )}
           <MockTestStyles mockTestCard1Object={mockTestCard1Object} />
    </div>

  );
}

function OtherInstructions({ sections,quizArr }) {
   const {
    overallTestTime,
    showCalci,
    isRestrictQuestionNavigation,
    isLockSections,
    testInterfaceTheme,
    cutOffPercent,
  } = quizArr;
  const getSectionQuestionCount = (secQuestions) => {
    try {
      const parsed = JSON.parse(secQuestions);
      return Array.isArray(parsed) ? parsed.length : 0;
    } catch {
      return 0;
    }
  };

  const totalQuestions = sections?.reduce(
    (sum, sec) => sum + getSectionQuestionCount(sec.secQuestions),
    0
  );

  const totalSections = sections?.length || 0;

  const SectionStatsTable = ({ sections }) => {
    if (!Array.isArray(sections) || !sections.length) return null;

    return (
      <div>
        <style>{`
          table {
            width: 100%;overflow-x:auto;
            border-collapse: collapse;
            margin-top: 16px;
            font-size: 14px;
            border: 1px solid #f5cb71;
          }
          thead {
            background: #ffd6a7;
          }
          th, td {
            border: 1px solid #fbddb0;
            padding: 8px 10px;font-size:16px;
            text-align: center;
          }
  
       
/* xs */
@media (max-width: 767px) { 
  th, td {
            
            padding: 8px 8px;font-size:10px;
            
          }}
        `}</style>

        <table>
          <thead>
            <tr>
              <th>Section Name</th>
              <th>Total Qs</th>
              <th>Marks</th>
              <th>Answered</th>
              {/* <th>Not Visited</th>
              <th>Marked</th> */}
            </tr>
          </thead>
          <tbody>
            {sections.map((sec, idx) => (
              <tr key={sec.ID || idx}>
                <td>{sec.sectionName}</td>
                <td>{getSectionQuestionCount(sec.secQuestions)}</td>
                <td>{sec.sectionStats?.totalMarks || 0}</td>
                <td>{sec.sectionStats?.answered || 0}</td>
                {/* <td>{sec.sectionStats?.notVisited || 0}</td>
                <td>
                  {(sec.sectionStats?.markedAndAnswered || 0) +
                    (sec.sectionStats?.markedAndNotAnswered || 0)}
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div style={styles.content}>
      {/* ================= SSC HEADER ================= */}
      <h2 >
        <div style={styles.bannerLogo2}>{quizArr?.testName?quizArr?.testName:"Test Name"}</div>
           <div style={styles.bannerSub}>
            
               <h3 style={styles.bannerRight}>{quizArr?.testStatus?JSON.parse(quizArr?.testStatus)?.post_title:"Type"}</h3>
            </div> </h2>

      <div style={styles.metaRow}>
        <div><b>Duration:</b>{overallTestTime ? `${overallTestTime} Minutes` : "loading..."} </div>
      </div>

      <div style={styles.boldUnderline}>
        Read the following instructions carefully.
      </div>

      {/* ================= BASIC INSTRUCTIONS ================= */}
      <ol style={styles.ol}>
        <li>
          The test contains <b>{totalSections}</b> sections having{" "}
          <b>{totalQuestions}</b> questions in total.
        </li>
        <li>
          Each question has <b>4 options</b>, out of which <b>only one</b> is
          correct.
        </li>
        <li>
          You must complete the test within <b>{overallTestTime ? `${overallTestTime} Minutes` : "loading..."}  minutes</b>.
        </li>
        {/* <li>
          You will be awarded <b>2 marks</b> for each correct answer and{" "}
          <b>0.25 marks</b> will be deducted for each wrong answer.
        </li> */}
        <li>
          There is <b>no negative marking</b> for unattempted questions.
        </li>
        {/* <li>
          You can attempt this test <b>only once</b>. Ensure that you submit the
          test before closing the browser.
        </li> */}
      </ol>

      {/* ================= SECTION TABLE ================= */}
      <h4 style={{ marginTop: 20 }}>
        Section-wise Question Distribution
      </h4>

      <SectionStatsTable sections={sections} />

      {/* ================= QUESTION TYPES ================= */}
      <div style={styles.subPoints}>
        <div style={styles.p}>
          <b>a.</b> MCQs have four choices out of which ONLY ONE is correct.
        </div>
        <div style={styles.p}>
          <b>b.</b> MSQs have four choices out of which ONE OR MORE than ONE
          choice(s) is/are correct.
        </div>
        <div style={styles.p}>
          <b>c.</b> For Numerical Answer Type (NAT) questions, answers must be
          entered using the on-screen keypad.
        </div>
      </div>
    </div>
  );
}


function StatusRow({ sectionStatsAll,color, label, dot }) {
  return (<>
    <div style={styles.statusRow}>
        <div className="palletInfoBtn"> <div className="palletNotAttempdedButtonSmall " 
         style={{background:"#ddd",color:"#333"}}
         >1</div>
             <div className="palletInfoTitle mockTestSubTitleFont"> You have NOT visited the question yet.
                
         </div> 
        </div></div> <div style={styles.statusRow}><div className="palletInfoBtn">
            <div className="palletAttempdedButtonSmall" 
         style={{}}
         >2</div>    <div className="palletInfoTitle mockTestSubTitleFont"> You have answered the question.</div> 
        </div></div> <div style={styles.statusRow}><div className="palletInfoBtn">
           <div className="palletNotAttempdedButtonSmall" 
         style={{}}
         >3</div>   <div className="palletInfoTitle mockTestSubTitleFont"> You have NOT answered the question.</div> 
        </div></div> <div style={styles.statusRow}>
        <div className="palletInfoBtn">
           <div className="palletNotAttempdedButtonSmall" 
         style={{}}
         ><div className="palletAttempdedButtonInnSmall"  style={{}}
         ></div>4</div>
           <div className="palletInfoTitle mockTestSubTitleFont"> You have NOT answered the question but have marked it for review.</div> 
        </div></div> <div style={styles.statusRow}><div className="palletInfoBtn">
           <div className="palletAttempdedButtonSmall" 
         style={{}}
         ><div className="palletAttempdedButtonInnSmall"  style={{}}
         ></div>5</div>    <div className="palletInfoTitle mockTestSubTitleFont"> You have answered the question and marked for review. This will be evaluated</div> 
        </div></div> 
    </>
  );
}

/* -------------------- STYLES -------------------- */

const styles = {
 

  banner: {
    height: 62,
    background: "#ffffff",
   
    display: "flex",
    alignItems: "center",flexWrap:"wrap",
    padding: "0 18px",
    justifyContent: "space-between",
  },
  bannerLeft: { display: "flex", alignItems: "center", gap: 10 },
  bannerLogo: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: 28,fontWeight:"bold",
    color: "#181919",
  }, bannerLogo2: {
   
    fontSize: 22,fontWeight:"bold",
    color: "#181919",
  },
  bannerSub: { fontSize: 12, color: "#666" ,  display: "flex",
   gap:"10px",
   
    justifyContent: "space-between"},
  bannerRight: { fontWeight: 800, color: "#333" },

  pageTitle: {
    background: "rgba(144, 202, 249,0.1)",
    padding: "10px 16px",
    fontSize: 20,
    fontWeight: 700,
    color: "#242525",
  },

  

  leftPanel: {
    background: "#fff",
   
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
  },
  scrollArea: {
    flex: 1,
    overflowY: "auto",
    padding: 18,
  },

  rightPanel: {
    background: "rgba(144, 202, 249,0.1)",
 
    
    justifyContent: "center",
    alignItems: "flex-start",
    padding: 22,
  },
  userBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 12,
  },
  avatar: {
    width: 90,
    height: 90,
    borderRadius: "50%",
    background: "#e8eef3",
    display: "grid",
    placeItems: "center",
    fontSize: 40,
    border: "1px solid #cfd8dc",
  },
  userName: { fontWeight: 700, color: "#333" },

  footerWrap: {
    background: "#fff",
    borderTop: "1px solid #cfd8dc",
  },

  footerCheck: {
    padding: "10px 14px",
    borderBottom: "1px solid #e8e8e8",
  },
  checkboxRow: {
    display: "flex",
    gap: 10,
    alignItems: "flex-start",
    fontSize: 13,
    color: "#333",
  },
  checkboxText: {
    lineHeight: 1.35, overflow: "hidden",textAlign: "left",
        display: "-webkit-box",
        webkitLineClamp: 2,
        webkitBoxOrient: "vertical",
        height:"36px",fontWeight:"bold",
  },

  footer: {
    padding: "14px 14px",
    display: "flex",
    alignItems: "center",gap:"10px",
    justifyContent: "space-between",
  },

  prevBtn: {
    padding: "10px 16px",
    background: "#fff",minWidth:"120px",
    border: "1px solid #bbb",
    cursor: "pointer",
  },
  nextBtn: {
    padding: "10px 16px",minWidth:"120px",
    background: "#fff",
    border: "1px solid #bbb",
    cursor: "pointer",
  },
  beginBtn: {
    padding: "12px 26px",minWidth:"180px",
    background: "#6fbbe7",
    border: "none",
    color: "#fff",
    fontWeight: 700,
    cursor: "pointer",
  },

  versionBar: {
    height: 22,
    background: "#4e6b7b",
    color: "#fff",
    fontSize: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  content: { color: "#222", fontSize: 14,height:"60vh", },
  h3: { margin: 0, marginBottom: 8, },
  sectionTitle: { fontWeight: 800,  marginBottom: 14 },
  boldUnderline: { fontWeight: 800, textDecoration: "underline", marginBottom: 14 },

  p: { marginBottom: 8 },
  ol: { paddingLeft:5, lineHeight: 1.6 },

  paletteBox: {
    width: 520,
    maxWidth: "100%",
    border: "1px solid rgba(144, 202, 249,0.7)",
    marginTop:"15px",  marginBottom:"15px",
  },
  statusRow: {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid rgba(144, 202, 249,0.7)",
  },
  statusIcon: {
    width: 52,
    height: 40,
    display: "grid",
    placeItems: "center",
    fontWeight: 800,
  },
  statusLabel: { padding: "0 10px", fontSize: 13 },

  subPoints: { marginTop: 10, paddingLeft: 12 },
};
